import "../../design.css";

import kitchen1 from "../../Assets/FoodStyling/inside-the-kitchen/kitchen1.jpg";
import kitchen2 from "../../Assets/FoodStyling/inside-the-kitchen/kitchen2.jpg";
import kitchen3 from "../../Assets/FoodStyling/inside-the-kitchen/kitchen3.jpg";
import kitchen4 from "../../Assets/FoodStyling/inside-the-kitchen/kitchen4.jpg";
import kitchen5 from "../../Assets/FoodStyling/inside-the-kitchen/kitchen5.jpg";
import kitchen6 from "../../Assets/FoodStyling/inside-the-kitchen/kitchen6.jpeg";
import kitchen7 from "../../Assets/FoodStyling/inside-the-kitchen/kitchen7.jpg";

import mushroom1 from "../../Assets/FoodStyling/mushrooms/mushroom1.jpg";
import mushroom2 from "../../Assets/FoodStyling/mushrooms/mushroom2.jpg";
import mushroom3 from "../../Assets/FoodStyling/mushrooms/mushroom3.jpg";
import mushroom4 from "../../Assets/FoodStyling/mushrooms/mushroom4.jpg";
import mushroom5 from "../../Assets/FoodStyling/mushrooms/mushroom5.jpg";
import mushroom6 from "../../Assets/FoodStyling/mushrooms/mushroom6.jpeg";
import mushroom7 from "../../Assets/FoodStyling/mushrooms/mushroom7.jpg";
import mushroom8 from "../../Assets/FoodStyling/mushrooms/mushroom8.jpg";
import mushroomgphx from "../../Assets/FoodStyling/mushrooms/graphic_orange.png";

import { useState } from "react";
import Masonry, { ResponsiveMasonry } from "react-responsive-masonry";

function getPhotoSet(string) {
  const PHOTOS = {
    mushroom: [
      mushroom6,
      mushroomgphx,
      mushroom1,
      mushroom8,
      mushroom3,
      mushroom4,
      mushroom5,
      mushroom7,
      mushroom2
    ],
    kitchen: [
      kitchen7,
      kitchen1,
      kitchen5,
      kitchen2,
      kitchen3,
      kitchen4,
      kitchen6,
    ]
  }
  return PHOTOS[string]
}





function PhotoGallery(props) {
  const [selected, setSelected] = useState(null);

  return (
    <>
      <div className="gallery-root">
        <div style={{ maxWidth: "80%", margin: "0 auto" }}>
          <ResponsiveMasonry columnsCountBreakPoints={{ 350: 1, 600: 2, 1000: 3 }}
          gutterBreakPoints={{ 350: "24px", 600: "50px", 900: "80px" }}>
            <Masonry>
              {getPhotoSet(props.galleryKey).map((src, i) => (
                <img key={i} src={src} alt="" onClick={() => setSelected(src)} />
              ))}
            </Masonry>
          </ResponsiveMasonry>
        </div>
      </div>
      {selected && (
        <div className="lightbox" onClick={() => setSelected(null)}>
          <img src={selected} alt="" />
        </div>
      )}
    </>
  );
}

export default PhotoGallery;